"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const axios_1 = __importDefault(require("axios"));
let ActionVisibility = class ActionVisibility extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.visibility = 'private';
    }
    mounted() {
        if (this.summaryData.isPublished) {
            this.visibility = 'public';
        }
        else {
            this.visibility = 'private';
        }
    }
    imgSrc(code) {
        if (code)
            return code;
        return null;
    }
    donwload() {
        const fileLink = document.createElement('a');
        fileLink.href = this.imgSrc(this.summaryData.qr.imgSrc);
        fileLink.setAttribute('download', 'QR.png');
        document.body.appendChild(fileLink);
        fileLink.click();
    }
    get trialId() {
        const url = window.location.href;
        const match = url.match(/\/trials\/(\d+)/);
        if (match) {
            const trialNumber = match[1];
            return trialNumber;
        }
        else {
            // console.log('No se encontró el id del trials');
        }
    }
    async changeVisibility() {
        if (this.visibility === 'public') {
            this.visibility = 'private';
        }
        else {
            this.visibility = 'public';
        }
        try {
            await axios_1.default.get('/trials/' + this.trialId + '/setIsPublished');
        }
        catch (e) {
            console.log(e);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionVisibility.prototype, "summaryData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionVisibility.prototype, "summaryConfigData", void 0);
ActionVisibility = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Toggle: bmk_ui_framework_1.Toggle,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
        },
    })
], ActionVisibility);
exports.default = ActionVisibility;
